"use strict";
var appn;
(function (appn) {
    var dialog;
    (function (dialog) {
        var singleEntryExport;
        (function (singleEntryExport) {
            function init() {
                onSelectedTemplateChanged();
                addEvents();
            }
            singleEntryExport.init = init;
            function addEvents() {
                $('.singleEntryExportLink').off().on('click', function (e) {
                    e.preventDefault();
                    const entryId = $(this).data('entryid');
                    const $singleEntryExportForm = $('#singleEntryExportForm');
                    const $singleEntryExportDialog = $('#singleEntryExportDialog');
                    $singleEntryExportForm.find('#selectedEntryId').remove();
                    $singleEntryExportForm.append(`<input type="hidden" id="selectedEntryId" name="Id" value="${entryId}" />`);
                    injectTemplateData($(this));
                    if ($singleEntryExportDialog.find('#SelectedTemplate option').length === 1)
                        $('.hideifnotemplate').hide();
                    else
                        $('.hideifnotemplate').show();
                    $singleEntryExportDialog.modal('show');
                    appn.dialog.showBillUpgradeOnClick(function () {
                        $('input[name="EmbedImageLinks"]').prop('checked', false);
                    });
                    appn.select.init();
                });
                $('#singleEntryExportForm').off().on('submit', function (e) {
                    $('#singleEntryExportForm input[name="exportGenericPdf"]').remove();
                    const currentOption = $('#singleEntryExportForm').find('#SelectedTemplate option:selected');
                    const dataAttr = $(currentOption).data();
                    if (dataAttr.hasOwnProperty('generic')) {
                        $('#singleEntryExportForm').append(`<input type="hidden" id="exportGenericPdf" name="exportGenericPdf" value="true" />`);
                        $('input[name="SelectedFileName"]').val(currentOption.val());
                    }
                    appn.ajax.post({
                        url: $(this).attr('action'),
                        data: $('#singleEntryExportForm').serialize(),
                        always: function () {
                            appn.notifications.updateNotificationTotal();
                            appn.ui.showExportConfirmation('Form Entry');
                            appn.dialog.hideLoading();
                        }
                    });
                    $('#singleEntryExportDialog').modal('hide');
                    return false;
                });
            }
            function onSelectedTemplateChanged() {
                $('#singleEntryExportDialog #SelectedTemplate').off().on('change', function () {
                    const $selectedOption = $('option:selected', this);
                    const attachmentNames = $selectedOption.data('attachmentnames');
                    dialog.toggleAttachmentNamesSelect(attachmentNames, $('.form-control-filename'));
                });
            }
            function injectTemplateData($exportLink) {
                const templateFilesToInject = $exportLink.data('templatefiles');
                if (!templateFilesToInject)
                    return;
                const $exportEntryDialog = $('#singleEntryExportDialog');
                let selectHtml = '<select class="form-control" id="SelectedTemplate" name="SelectedTemplate">';
                let hasAlreadyAddedGroup = false;
                let addedGroupName = '';
                $(templateFilesToInject).each(function (i, file) {
                    if ((file.Group && file.Group.Name) && (!hasAlreadyAddedGroup || file.Group.Name !== addedGroupName)) {
                        selectHtml += `<optgroup label="${file.Group.Name}"></optgroup>`;
                        hasAlreadyAddedGroup = true;
                        addedGroupName = file.Group.Name;
                    }
                    selectHtml += `<option value="${file.Value}" ${file.DataTag}='${file.DataValue}'>${file.Text}</option>`;
                });
                selectHtml += '</select>';
                const $injectTemplateFileDropdown = $exportEntryDialog.find('.injectTemplateFileDropdown');
                $injectTemplateFileDropdown.html(selectHtml);
                onSelectedTemplateChanged();
            }
        })(singleEntryExport = dialog.singleEntryExport || (dialog.singleEntryExport = {}));
    })(dialog = appn.dialog || (appn.dialog = {}));
})(appn || (appn = {}));
(function (appn) {
    var dialog;
    (function (dialog) {
        var bulkEntryExport;
        (function (bulkEntryExport) {
            function init() {
                const types = ['bulk-export-pdf', 'bulk-export-word', 'bulk-export-excel'];
                types.forEach(function (type, index) {
                    const template = $(`.card-planejane.${type} #Template.${type}`);
                    dialog.toggleAttachmentNamesSelect($('option:selected', template).data('attachmentnames'), $(`.form-control-filename-bulk[data-target='${type}']`), type);
                    template.on('change', function () {
                        dialog.toggleAttachmentNamesSelect($('option:selected', this).data('attachmentnames'), $(`.form-control-filename-bulk[data-target='${type}']`), type);
                    });
                });
            }
            bulkEntryExport.init = init;
            function bulkExportSetValues(type) {
                const selectedFileName = $('input[name="SelectedFileName"]');
                const selectedTemplate = $('input[name="SelectedTemplate"]');
                let format = appn.emptyString;
                switch (type) {
                    case 'BulkPDF':
                        format = 'bulk-export-pdf';
                        break;
                    case 'BulkWord':
                        format = 'bulk-export-word';
                        break;
                    case 'BulkExcel':
                        format = 'bulk-export-excel';
                        break;
                }
                const templateString = $(`.card-planejane.${format} select.${format}#Template`).val();
                const filenameString = $(`.card-planejane.${format} select.${format}#FileName`).val();
                if (templateString)
                    selectedTemplate.val(templateString);
                if (filenameString)
                    selectedFileName.val(filenameString);
                $('#manageForm input[name="exportGenericPdf"]').remove();
                const currentOption = $(`.card-planejane.${format} select.${format}#Template option:selected`);
                const dataAttr = $(currentOption).data();
                if (dataAttr.hasOwnProperty('generic') && format === 'bulk-export-pdf')
                    $('#manageForm').append(`<input type="hidden" id="exportGenericPdf" name="exportGenericPdf" value="true" />`);
            }
            bulkEntryExport.bulkExportSetValues = bulkExportSetValues;
        })(bulkEntryExport = dialog.bulkEntryExport || (dialog.bulkEntryExport = {}));
    })(dialog = appn.dialog || (appn.dialog = {}));
})(appn || (appn = {}));
